import React from 'react';
import { startCase } from 'lodash';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import horseTrainingAbilityEnum from '~/commons/enums/horseTrainingAbility';

const defaults = {
  owner: '',
  horse: {
    mint: '',
  },
  status: '',
  createdAt: '',
  orig: {},
  target: {},
};

const FormTraining = ({
  training,
}) => (
  <FormResource
    {...{
      defaults,
      // schema: object({
      //   profitTraining: number().min(0),
      // }),
      stored: training,
      api: '/api/site/trains',
      options: {omitIds: false},
    }}
  >
    <div className="form-row">
      <div className="col">
        <FormGroup name="owner" disabled/>
      </div>
      <div className="col">
        <FormGroup name="horse.mint" disabled/>
      </div>
      <div className="col">
        <FormGroup name="status" disabled/>
      </div>
      <div className="col">
        <FormGroup name="createdAt" disabled/>  
      </div>
    </div>
    <div className="form-row">
      <div className="col" />
      {Object.values(horseTrainingAbilityEnum).map(ability => (
        <div className="col">
          <label>{startCase(ability)}</label>
        </div>
      ))}
    </div>
    <div className="form-row">
      <div className="col">
        <label>Before</label>
      </div>
      {Object.values(horseTrainingAbilityEnum).map(ability => (
        <div className="col">
          <FormGroup name={`orig.${ability}`} label={null} disabled/>
        </div>
      ))}
    </div>
    <div className="form-row">
      <div className="col">
        <label>After</label>
      </div>
      {Object.values(horseTrainingAbilityEnum).map(ability => (
        <div className="col">
          <FormGroup name={`target.${ability}`} label={null} disabled/>
        </div>
      ))}
    </div>
    {/* <div className="form-row">
      <div className="col">
      <FormGroup name="orig.explosiveness" disabled/>
      </div>
      <div className="col">
      <FormGroup name="target" disabled/>
      </div>
      <div className="col">
      <FormGroup name="profitTraining" label="Profit Training" disabled/>  
      </div>
    </div> */}
  </FormResource>
);

export default FormTraining;
